module.exports = __webpack_public_path__ + "img/Self-Evaluation-App.7df8bf60.svg";